import { Action, Selector, State, StateContext } from "@ngxs/store";
import { AddAzureAccount } from "./account.actions";
import { AzureAdAccountModel } from "src/app/domain/models/azure-ad/account.model";

@State({
    name: 'account',
    defaults: {
        posts: undefined
    }
})
export class AzureAccountState {
    @Selector()
    static getPosts(state: AzureAdAccountModel) { return state; }

    // Añade un nuevo post al estado
    @Action(AddAzureAccount)
    add({ getState, patchState }: StateContext<AzureAdAccountModel>, { payload }: AddAzureAccount) {
        const state = getState();//stateActual
        patchState(
            payload
        );
    }

}